import angular from 'angular';
import FeaturedSliderComponent from './featured-slider.component';

let FeaturedSliderModule = angular.module('home.featuredSlider', [])
    .component('featuredSlider', FeaturedSliderComponent);

export default FeaturedSliderModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/featured-slider/featured-slider.js
 **/